import React from 'react';
import Left from './Left';


function Right() {
  return (
    <div className="App">
      <Left tooltipText="Custom Tooltip" />
    </div>
  );
}

export default Right;
